module.exports = __webpack_public_path__ + "static/media/logo.faf7b239.svg";